<script setup lang="ts">
import type { IAiChatOrganization } from '../types'
import { localizedField } from '../utils'

const props = defineProps<{ item: IAiChatOrganization }>()
const { t, locale } = useI18n()

const title = computed(() => localizedField(props.item.title, locale.value))
const logoSrc = computed(() => (props.item.logo ? useAsset(props.item.logo) : null))

const productLinks = computed(() => {
  const p: { deposits_count?: number; credits_count?: number; cards_count?: number } | undefined =
    props.item.products
  if (!p) return []
  return [
    p.credits_count && { label: t('common.credits'), count: p.credits_count },
    p.deposits_count && { label: t('common.deposits'), count: p.deposits_count },
    p.cards_count && { label: t('common.cards'), count: p.cards_count }
  ].filter(Boolean) as { label: string; count: number }[]
})
</script>

<template>
  <NuxtLink :to="item.url" class="AiCard group">
    <div class="flex items-center gap-2">
      <NuxtImg
        v-if="logoSrc"
        :src="logoSrc"
        :alt="title"
        width="32"
        height="32"
        class="OrganizationLogo !h-8 !w-8 !min-w-8"
      />
      <div class="min-w-0 flex-1">
        <div class="truncate text-sm font-semibold text-gray-900 group-hover:text-blue-600">
          {{ title }}
        </div>
        <div class="text-xs text-gray-500">{{ item.type_label }}</div>
      </div>
      <div v-if="item.rating" class="shrink-0 text-xs font-semibold text-amber-500">
        ★ {{ item.rating }}
      </div>
    </div>
    <div v-if="productLinks.length" class="mt-2 flex flex-wrap gap-2">
      <span
        v-for="link in productLinks"
        :key="link.label"
        class="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600"
      >
        {{ link.label }}: {{ link.count }}
      </span>
    </div>
  </NuxtLink>
</template>
